import { render, staticRenderFns } from "./pointChange.vue?vue&type=template&id=4d2602e8&scoped=true&"
import script from "./pointChange.vue?vue&type=script&lang=js&"
export * from "./pointChange.vue?vue&type=script&lang=js&"
import style0 from "./pointChange.vue?vue&type=style&index=0&id=4d2602e8&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2602e8",
  null
  
)

export default component.exports